import { Flex, KdsSpinner } from "@kazaar-platform/design-system";
import { FormatIcu } from "@tolgee/format-icu";
import {
  BackendFetch,
  DevTools,
  LanguageStorage,
  Tolgee,
  TolgeeProvider,
} from "@tolgee/react";

import { useAtomValue } from "jotai";
import { type ReactNode, useEffect } from "react";
import {
  AVAILABLE_LANGS_OPTIONS,
  DEFAULT_LANG,
} from "@/constants/languages.constants";
import { authLanguageAtom, userAtom } from "@/store";

const isDev = import.meta.env.DEV;

export const tolgee = Tolgee()
  .use(FormatIcu())
  .use(LanguageStorage())
  .use(isDev ? DevTools() : undefined)
  // CDN for loading translations dynamically (prod/preview)
  .use(
    !isDev && import.meta.env.VITE_APP_TOLGEE_CDN_URL
      ? BackendFetch({ prefix: import.meta.env.VITE_APP_TOLGEE_CDN_URL })
      : undefined
  )
  .init({
    defaultLanguage: DEFAULT_LANG,
    fallbackLanguage: DEFAULT_LANG,
    availableLanguages: AVAILABLE_LANGS_OPTIONS,
    // Config dev uniquement
    ...(isDev && {
      tagNewKeys: ["draft"],
      apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
      apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,
      observerOptions: {
        highlightKeys: ["Alt"],
      },
      onTranslationChange: {
        setToReview: true,
      },
    }),
  });

export const TranslationProvider = ({ children }: { children: ReactNode }) => {
  const language = useAtomValue(authLanguageAtom);
  const user = useAtomValue(userAtom);

  useEffect(() => {
    void tolgee.changeLanguage(user?.preferredLanguage || language);
  }, [language, user?.preferredLanguage]);

  //TOREFACTO : use Container component when available in the design system
  return (
    <TolgeeProvider
      tolgee={tolgee}
      fallback={
        <Flex w="100vw" h="100vh" align="center" justify="center">
          <KdsSpinner size="lg" />
        </Flex>
      }
    >
      {children}
    </TolgeeProvider>
  );
};
